import { render, staticRenderFns } from "./lang-toggle.vue?vue&type=template&id=6f69b79f&scoped=true&"
import script from "./lang-toggle.vue?vue&type=script&lang=ts&"
export * from "./lang-toggle.vue?vue&type=script&lang=ts&"
import style0 from "./lang-toggle.vue?vue&type=style&index=0&id=6f69b79f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f69b79f",
  null
  
)

export default component.exports